import { MdClose } from 'react-icons/md'
import IconButton from '@mui/material/IconButton'
import Snackbar from '@mui/material/Snackbar'
import isNumber from 'lodash/isNumber'

import { useAppDispatch, useAppSelector } from '../../../hooks'
import { selectSnackbarData, setSnackbarData } from '../../../imup/slices/common'

import './snackbar.scss'

export enum SnackbarType {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
}

export const SNACKBAR_DURATION = {
    SHORT: 3000,
    LONG: 5000,
    VERY_LONG: 8000,
} as const

export type SnackbarDuration =
    | typeof SNACKBAR_DURATION.SHORT
    | typeof SNACKBAR_DURATION.LONG
    | typeof SNACKBAR_DURATION.VERY_LONG

export const SnackBar = () => {
    const dispatch = useAppDispatch()

    const snackbarData = useAppSelector(selectSnackbarData)

    const handleCloseSnackbar = () => {
        dispatch(setSnackbarData(null))
    }

    if (!snackbarData) return null

    const { body, type, anchorOrigin, autoHideDuration } = snackbarData

    return (
        <Snackbar
            action={
                <IconButton aria-label="close" color="inherit" onClick={handleCloseSnackbar} size="small">
                    <MdClose />
                </IconButton>
            }
            anchorOrigin={anchorOrigin}
            autoHideDuration={isNumber(autoHideDuration) ? autoHideDuration : null}
            className={type}
            message={body}
            onClose={handleCloseSnackbar}
            open={!!snackbarData}
        />
    )
}
